<script setup lang="ts">
// 郵便番号から住所を検索可能なフォーム
interface Props {
  postnum?: string;
  address?: string;
  required?: boolean;
}

const id_post = useUid();
const id_address = useUid();

const props = withDefaults(defineProps<Props>(), {
  postnum: "",
  address: "",
  required: false,
});

const emit = defineEmits<{
  "update:postnum": [value: string];
  "update:address": [value: string];
}>();

// 郵便番号
const postNumber = computed({
  get() {
    return props.postnum;
  },
  set(newValue) {
    emit("update:postnum", newValue);
  },
});

// 住所
const addressText = computed({
  get() {
    return props.address;
  },
  set(newValue) {
    emit("update:address", newValue);
  },
});

// 郵便番号から検索した住所を入れる
function setAddress(e: string) {
  addressText.value = e;
}
</script>

<template>
  <FormZipCodeInput
    v-model="postNumber"
    label2="例:1234567"
    :required="required"
    :id="id_post"
    @onSearch="setAddress"
  />
  <FormInput
    v-model="addressText"
    label="住所"
    placeholder="お住まいの住所"
    alert="お住まいの住所をご入力ください"
    :id="id_address"
    :required="required"
  />
</template>
